import { useEffect, useState } from "react";
import { GameStatus } from "../../models/GameStatus";
import store from "../../store/store";
import Button from "../common/Button";
import { gameActions } from "../Game/gameSlice";
import PlayerPicture from "../Players/PlayerPicture";
import "./Sentence.scss";
import classNames from 'classnames';
import { PlayerPublic } from "../../models/Player";

export default function Sentence() {

  const [sentence, setSentence] = useState("");
  const [sentenceExplanation, setSentenceExplanation] = useState("");
  const [isBecomeStorytellerDisabled, setIsBecomeStorytellerDisabled] = useState(true);
  const [finishButtonLabel, setFinishButtonLabel] = useState('');

  useEffect(() => {
    const randomNumber = Math.floor(Math.random() * 100);

    if (randomNumber < 97) {
      setFinishButtonLabel('Finish turn'); // 97% chance
    } else {
      setFinishButtonLabel('Finish him'); // 3% chance
    }
  }, []); // Empty dependency array ensures this runs only once after the initial render

  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      setTimeout(() => {
        setIsBecomeStorytellerDisabled(false);
      }, 3 * 1000);
    } else {
      setIsBecomeStorytellerDisabled(false);
    }
  }, []);

  const gameState = store.getState().game;
  const userState = store.getState().user;
  const players = gameState.players;
  const player = gameState.player;

  const currentStoryteller = gameState.players.find(it => it.isStoryteller);

  const isSentence = gameState.status === GameStatus.SENTENCE;

  const isFormVisible =
    isSentence &&
    player?.data.isStoryteller &&
    player.matchCardId;

  const isFormDisabled = !player?.matchCardId;

  const isSentenceExplanationStatus = gameState.status === GameStatus.SENTENCE || gameState.status === GameStatus.TURN_RESULTS;

  function handleSubmit(e: any) {
    e.preventDefault();
    if (!gameState.isConnected) {
      return;
    }
    if (!userState.user.confirmActionEnabled || window.confirm('Are you sure you want to send this sentence?')) {
      if (player) {
        store.dispatch(gameActions.submitSentence({
          gameId: gameState.gameId,
          playerId: player.data.playerId,
          sentence: sentence,
          sentenceExplanation: sentenceExplanation,
          matchCardId: player?.matchCardId
        }));
      }
    }
  }
  function handleReset(e: any) {
    e.preventDefault();
    if (player) {
      store.dispatch(gameActions.selectMatchCard({
        gameId: gameState.gameId,
        playerId: player.data.playerId,
        sentence: '',
        matchCardId: ''
      }));
    }
  }

  const isFinished = gameState.player?.data.hasFinished;
  const isResults = gameState.status === GameStatus.TURN_RESULTS;

  function finish() {
    if (gameState.player) {
      store.dispatch(gameActions.submitFinished({ gameId: gameState.gameId, playerId: gameState.player.data.playerId }));
    }
  }

  function becomeStoryteller() {
    if (!gameState.isConnected) {
      return;
    }
    if (gameState.player) {
      store.dispatch(gameActions.submitStoryteller({ gameId: gameState.gameId, playerId: gameState.player.data.playerId }));
    }
  }

  const noSentenceMessage = currentStoryteller
    ? `Storyteller: ${currentStoryteller?.username}`
    : ``;

  const sentenceContent = gameState.sentence ? `"${gameState.sentence}"` : noSentenceMessage;
  const sentenceHelp = !player?.matchCardId ? 'Pick a card' : '';

  const sentenceText = player?.data.isStoryteller && !gameState.sentence
    ? sentenceHelp
    : sentenceContent;

  const playerPictureVisible = currentStoryteller?.playerId !== player?.data.playerId || !!gameState.sentence;

  const classes = classNames({
    'sentence': true,
    'sentence_storyteller': player?.data.isStoryteller && !gameState.sentence
  });

  const pendingPlayers = players.filter(it => !it.hasFinished);
  const isPlayerLastPending = !player?.data.hasFinished && pendingPlayers.length === 1;

  return (
    <div className={classes}>
      {playerPictureVisible &&
        <PlayerPicture player={currentStoryteller || null} size={45} />
      }

      {!isFormVisible &&
        <div className="sentence_text_block">
          <div className="sentence_text">{sentenceText}</div>
          {(isSentenceExplanationStatus && gameState.sentenceExplanation) &&
            <>
              <div className="sentence_text sentence_text_explanation">"{gameState.sentenceExplanation}"</div>
            </>
          }
        </div>
      }

      {isFormVisible &&
        <form className="sentence_form" onSubmit={handleSubmit}>
          <fieldset disabled={isFormDisabled}>
            <label>
              <span>Sentence:</span>
              <input
                autoFocus
                readOnly={false}
                maxLength={256}
                onChange={e => setSentence(e.target.value)}
                type="text"
                name="sentence"
                placeholder=""
              />
            </label>
            <Button
              onClick={handleSubmit}
              text="Send"
              disabled={!sentence || !player?.matchCardId}
            />
            <Button
              onClick={handleReset}
              text="×"
              classes="danger sentence_form_reset"
              confirmPrompt={userState.user.confirmActionEnabled ? 'Are you sure you want reset your sentence?' : null}
            />
          </fieldset>

          <label className="sentence_form_label-optional">
            <span>
              Explanation
              <small>(Visible only after round)</small>
            </span>
            <input
              readOnly={false}
              maxLength={256}
              onChange={e => setSentenceExplanation(e.target.value)}
              type="text"
              name="sentenceExplanation"
              placeholder=""
            />
          </label>
        </form>
      }

      <div className="sentence_button">
        {isResults &&
          <>
            <Button
              onClick={() => finish()}
              disabled={isFinished}
              text={finishButtonLabel}
              classes={isPlayerLastPending ? '' : 'green'}
              // confirmPrompt={userState.user.confirmActionEnabled ? `Are you sure you want to finish this round?` : null}
            />
          </>
        }
        {!currentStoryteller && isSentence &&
          <Button
            confirmPrompt={userState.user.confirmActionEnabled ? 'Are you sure you want to become the first storyteller?' : null}
            onClick={() => becomeStoryteller()}
            disabled={isBecomeStorytellerDisabled}
            text="Become storyteller"
          />
        }
      </div>
    </div>
  )
}
